import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DeltaBarAdapter = ({ spec, containerRef }) => {
  const { config = {}, data = [] } = spec;
  const firstRow = data[0] || {};
  const rowKeys = Object.keys(firstRow);

  const keyColumn =
    config.keyColumn ||
    ["brand", "topic", "entity", "name", "key", "label"].find((k) => k in firstRow) ||
    rowKeys.find((k) => typeof firstRow[k] === "string") ||
    rowKeys[0] ||
    "brand";

  const valueColumn =
    config.valueColumn ||
    ["delta", "change", "diff", "net_change", "value", "share_change"].find((k) => k in firstRow) ||
    rowKeys.find((k) => k !== keyColumn && typeof firstRow[k] === "number") ||
    rowKeys.filter((k) => k !== keyColumn)[0] ||
    "delta";

  const chartData = useMemo(() => {
    const labels = data.map((item) => item[keyColumn]);
    const values = data.map((item) => Number(item[valueColumn]) || 0);

    // Dynamic background colors: Green for positive change, Red for negative change
    const backgroundColors = values.map((val) =>
      val >= 0 ? "rgba(22, 163, 74, 0.75)" : "rgba(220, 38, 38, 0.75)"
    );
    const borderColors = values.map((val) =>
      val >= 0 ? "#16a34a" : "#dc2626"
    );

    return {
      labels,
      datasets: [
        {
          label: "Net Share Change (%)",
          data: values,
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1,
          borderRadius: 3,
        },
      ],
    };
  }, [data, keyColumn, valueColumn]);

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `Change: ${context.raw > 0 ? "+" : ""}${context.raw}%`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: { color: "#f1f5f9" },
        ticks: { font: { size: 11 } },
      },
      y: {
        grid: { display: false },
        ticks: { font: { size: 11 }, autoSkip: false },
      },
    },
  };

  const chartHeight = Math.max(260, data.length * 36 + 60);

  return (
    <div ref={containerRef} className="assistant-chart-render-wrapper delta-bar-render-wrapper" style={{ height: `${chartHeight}px` }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default DeltaBarAdapter;
